import { memo } from "react";
import TaskItemTemplate from "./TaskItemTemplate";

function TaskItem({
  taskKey,
  isOpen,
  isDone,
  isLocked,
  isOptional,
  hasMissingValue,
  linkedThoughtRecordKey,
  linkedMeditationRecordKey,
  setNumber,
  hasConnectionLine,
  connectionTop,
  connectionHeight,
  isFirstOfSet,
  isLastOfSet,
}: {
  taskKey: string;
  isOpen: boolean;
  isDone: boolean;
  isLocked?: boolean;
  isOptional?: boolean;
  hasMissingValue?: boolean;
  linkedThoughtRecordKey?: string;
  linkedMeditationRecordKey?: string;
  setNumber?: number;
  hasConnectionLine?: boolean;
  connectionTop?: number;
  connectionHeight?: number;
  isFirstOfSet?: boolean;
  isLastOfSet?: boolean;
}) {
  return (
    <TaskItemTemplate
      key={taskKey}
      taskKey={taskKey}
      isOpen={isOpen}
      isDone={isDone}
      isLocked={isLocked}
      isOptional={isOptional}
      hasMissingValue={hasMissingValue}
      linkedThoughtRecordKey={linkedThoughtRecordKey}
      linkedMeditationRecordKey={linkedMeditationRecordKey}
      setNumber={setNumber}
      hasConnectionLine={hasConnectionLine}
      connectionTop={connectionTop}
      connectionHeight={connectionHeight}
      isFirstOfSet={isFirstOfSet}
      isLastOfSet={isLastOfSet}
    />
  );
}

export default memo(TaskItem);
